import Ghost from "./Ghost";
import Link from "./Link";
import Primary from "./Primary";
import Secondary from "./Secondary";
import Outline from "./Outline";
const Button = {
  Ghost,
  Link,
  Primary,
  Secondary,
  Outline,
};
export default Button;
